
























































module.exports =
  name: 'settings_general'
  metaInfo: -> { title: @$t('My Account') }
  data: ->
    loading: false
    errors: []
    passwords:
      current:          undefined
      new:              undefined
      new_confirmation: undefined
  computed:
    form: ->
      first_name:       @$store.state.user.userdata.first_name
      email:            @$store.state.user.userdata.email
      first_day:        @$store.state.user.userdata.first_day
      default_currency: @$store.state.user.userdata.default_currency
      settings:         @$store.state.user.userdata.settings
    store_user: -> @$store.state.user.userdata
    payment_plan: -> @$store.getters.payment_plan
  methods:
    saveUser: ->
      @loading = true
      promise = HM_API.update_user(@form, @passwords)
      promise.then (res) =>
        @errors = res.errors
        @loading = false
        unless @errors.length
          location.reload()
      # promise.catch -> location.reload()
